import { AddTodo } from './components/AddTodo/AddTodo';
import './App.css';

function App() {
  return (
    <div className="app">
      <AddTodo />
    </div>
  );
}

export default App;
